export { default as ListadoSalidas } from "./Listado";
